export default {
    authorized: state => state.status.loggedIn
}